import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CarditResditBestPracticeElementsSelectors';

export class CarditResditBestPracticeElementsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChart: false,
      chartMeta: {},
    };
  }

  setChartMeta = (chartMeta) => {
    this.setState({
      chartMeta,
      showChart: true,
    });
  };

  closeChart = () => {
    this.setState({
      showChart: false,
    });
  };

  render() {
    return (
      <Report
        reportId={ReportDefinitions.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.columns(this.setChartMeta)}
        showChart={this.state.showChart}
        chartMeta={this.state.chartMeta}
        closeChart={this.closeChart}
        className="despatchMeasurementsDailyEvolutionReport"
        prepareData={(data) => data.filter(d => d.operator.toLowerCase() !== 'total')}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

CarditResditBestPracticeElementsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.func,
};

export default connect(mapStateToProps)(CarditResditBestPracticeElementsContainer);
